<template>
  <div class="pt-3 px-3">
    <ValidationObserver ref="form" tag="div" class="row">
      <div class="col-12 pt-2">
        <ValidationProvider
          v-slot="{ errors, validate }"
          mode="lazy"
          rules="required"
          :custom-messages="{ required: 'Favor escriba razón.' }"
        >
          <CustomTextArea
            v-model="model.reason"
            :disabled="readonly"
            label="Razón:"
            regular-label
            :maxlength="3000"
            show-char-count
            :count-classes="['d-block text-right', 'small-counter']"
            :error="errors[0]"
            custom-error-msg="Favor de documentar la razón de denegación."
            @input="validate"
          />
        </ValidationProvider>
      </div>

      <div v-if="!readonly" class="col-12 pt-2 text-right">
        <ActionButton
          text="Cancelar"
          i="fas fa-times-circle"
          variant="custom-btn-return outline-danger"
          class="mr-2"
          @click="cancel"
        />
        <ActionButton
          text="Continuar"
          i="fas fa-arrow-alt-circle-right"
          variant="custom-btn-return outline-success"
          @click="submit"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import alert from '@/mixin/alert.mixin';

const initialModel = () => ({ reason: null });

export default {
  name: 'DenegadoForm',
  mixins: [alert],
  components: {
    CustomTextArea,
    ActionButton,
  },
  props: {
    // { id: null, name: null, reason: null }
    currentStatus: {
      required: true,
      default: null,
      validator: (prop) => typeof prop === 'object' || prop === null,
    },
    currentStatusTarget: {
      required: true,
      default: null,
      validator: (prop) => typeof prop === 'object' || prop === null,
    },
    readonly: { type: Boolean, default: false },
  },
  data: () => ({ model: initialModel() }),
  methods: {
    async submit() {
      if (this.readonly) return;
      const valid = await this.$refs['form'].validate();
      if (valid) {
        const model = {
          currentStatusTargetId: this.currentStatusTarget.id,
          model: this.model,
        };
        this.$emit('submit', model);
      } else {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información solicitada.',
          'error'
        );
      }
    },
    cancel() {
      this.model = initialModel();
      this.$refs['form'].reset();
      this.$emit('cancel');
    },
  },
};
</script>
